import NavBar from "../NavBar";

const Resume = () => {
    return (
        <div>
            <NavBar />
            PLACEHOLDER
        </div>
    )
}

export default Resume;